import { ContratoCdc } from '../interfaces/contrato-cdc.model';
import { DateCalculatorService } from '../services/date-calculator.service';

/**
 * Factory responsável por converter objetos do domínio de Contratos CDC
 * para formatos utilizados na interface de usuário.
 */
export class ContratoCdcFactory {
  /**
   * Converte um objeto ContratoCdc para o formato esperado pela tabela de Histórico de Financiamento.
   * Realiza o mapeamento de campos e formatação de valores monetários.
   * 
   * @param contrato Objeto ContratoCdc retornado pela API
   * @param dateCalculatorService Serviço para cálculo de datas (opcional, se não passado usa lógica interna simplificada ou retorna '-')
   * @returns Objeto com as chaves esperadas pela tabela de histórico (com espaços nos nomes)
   */
  static convertToHistoricoFinanciamento(
    contrato: ContratoCdc & { dataFimExibicao?: string },
    dateCalculatorService?: DateCalculatorService
  ): any {
    // Prioriza data de fim calculada previamente (com 6 meses, período vigente para elegibilidade)
    const dataFim = contrato.dataFimExibicao
      ? contrato.dataFimExibicao
      : dateCalculatorService
        ? dateCalculatorService.calcularDataFimContrato(contrato.dataInicio, contrato.prazo)
        : '-';

    return {
      'Inicio': contrato.dataInicio,
      'Fim': dataFim,
      'Status': contrato.status,
      'Chassi': contrato.chassi || '-',
      'Vl. Veículo': contrato.valorTotal ? `R$ ${contrato.valorTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-',
      'Vl. Parcela': contrato.valorPrestacao ? `R$ ${contrato.valorPrestacao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-',
      'Prazo': contrato.prazo ? `${contrato.prazo} meses` : '-'
    };
  }
}
